import { FileModel, AttachmentModel } from "@interfaces/index";

export const getFileExtension = (file: FileModel | AttachmentModel) =>
  file.originalName.split(".").slice(-1)[0];
